// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__YN2JF","change-color-on-hover":"BookNowBtn_change-color-on-hover__zEvtV","button":"BookNowBtn_button__SuAB+"};